import Axios from "../utils/http-request";
import { AxiosErrorResponse } from "../interface/api_request";

// Get all outsourced staffing requests
export const apiGetOutsourcedRequests = async (values: {
  page: string;
  filter: string;
}) => {
  try {
    const uri = `/admin/outsourced-staffing/requests?page=${values.page}${values.filter ? `&${values.filter}` : ""}`;

    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Get single outsourced request details
export const apiGetOutsourcedRequestById = async (values: {
  requestId: string;
}) => {
  try {
    const uri = `/admin/outsourced-staffing/request/${values.requestId}`;

    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Get applications for outsourced job
export const apiGetOutsourcedJobApplications = async (values: {
  requestId: string;
  page: string;
  filter: string;
}) => {
  try {
    const uri = `/admin/outsourced-staffing/request/${values.requestId}/applications?page=${values.page}&${values.filter}`;

    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Get single application details
export const apiGetOutsourcedApplicationDetails = async (values: {
  requestId: string;
  applicationId: string;
}) => {
  try {
    const uri = `/admin/outsourced-staffing/request/${values.requestId}/application/${values.applicationId}`;

    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Shortlist candidate
export const apiShortlistCandidate = async (data: {
  requestId: string;
  applicationId: string;
  notes?: string;
}) => {
  try {
    const uri = `/admin/outsourced-staffing/request/${data.requestId}/application/${data.applicationId}/shortlist`;

    const requestBody = {
      notes: data.notes,
    };

    return await Axios.put(uri, requestBody);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Schedule interview
export const apiScheduleOutsourcedInterview = async (data: {
  requestId: string;
  applicationId: string;
  interview_date: string;
  location: string;
  details: string;
  type: string;
  participants?: string[];
}) => {
  try {
    const uri = `/admin/outsourced-staffing/request/${data.requestId}/application/${data.applicationId}/interview`;

    const requestBody = {
      interview_date: data.interview_date,
      location: data.location,
      details: data.details,
      type: data.type,
      participants: data.participants,
    };

    return await Axios.put(uri, requestBody);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Hire candidate
export const apiHireOutsourcedCandidate = async (data: {
  requestId: string;
  application_id: string;
  salary: number;
  employment_type: string;
  work_type: string;
  start_date: string;
  end_date?: string;
  contract_duration?: string;
  position: string;
  benefits?: string[];
  note?: string;
}) => {
  try {
    const uri = `/admin/outsourced-staffing/request/${data.requestId}/hire`;

    const requestBody = {
      application_id: data.application_id,
      salary: data.salary,
      employment_type: data.employment_type,
      work_type: data.work_type,
      start_date: data.start_date,
      end_date: data.end_date,
      contract_duration: data.contract_duration,
      position: data.position,
      benefits: data.benefits,
      note: data.note,
    };

    return await Axios.post(uri, requestBody);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Assign admin to request
export const apiAssignAdminToRequest = async (data: {
  requestId: string;
  admin_id: string;
  notes?: string;
}) => {
  try {
    const uri = `/admin/outsourced-staffing/request/${data.requestId}/assign`;

    const requestBody = {
      admin_id: data.admin_id,
      notes: data.notes,
    };

    return await Axios.put(uri, requestBody);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiUpdateOutsourcingStatus = async (params: {
  requestId: string;
  status: string;
  notes?: string;
}) => {
  try {
    const uri = `/admin/outsourced-staffing/request/${params.requestId}/status`;
    const response = await Axios.put(uri, {
      status: params.status,
      notes: params.notes,
    });
    return response.data;
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg:
        e?.response?.data?.message ||
        e?.message ||
        "Failed to update outsourcing status",
    };
  }
};
